// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RevenueSourceType {
  EshopTransfer = "ESHOP_TRANSFER",
  EshopPayGate = "ESHOP_PAY_GATE",
  KioskPayGate = "KIOSK_PAY_GATE",
  Salespoint = "SALESPOINT",
}
export default RevenueSourceType;
